<template>
  <b-modal
    id="copy-to-layout-modal"
    title="Copy to Layout"
    centered
    ok-title="Copy"
    :ok-disabled="!selectedLayout && createNewLayout === 'false'"
    @ok="handleSave"
    @cancel="closeModal"
  >
    <!-- Layout Option Radio Group -->
    <b-form-group
      label="Layout Options"
      class="mb-3"
    >
      <b-form-radio-group
        v-model="createNewLayout"
        name="layout-option"
      >
        <b-form-radio value="false">
          Use existing layout
        </b-form-radio>
        <b-form-radio value="true">
          Create new layout
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <!-- New Layout Name Input -->
    <b-form-group
      v-if="createNewLayout === 'true'"
      label="New Layout Name"
      class="mb-3"
    >
      <b-form-input
        v-model="newLayoutName"
        placeholder="Enter new layout name"
        required
      />
    </b-form-group>

    <Multiselect
      v-if="createNewLayout === 'false'"
      v-model="selectedLayout"
      :options="layouts"
      :loading="isLoading"
      searchable
      multiple
      :custom-label="customLabel"
      track-by="id"
      class="mb-3"
      placeholder="Add to layout"
      @search-change="searchCustomerLayouts"
      @select="(option) => selectedLayout = [option]"
    >
      <template
        v-if="layouts.length < layoutsTotalCount"
        #afterList
      >
        <div class="load-more-btn">
          <b-button
            :disabled="isLoading"
            variant="outline-primary"
            @click="getLayouts"
          >
            Load More
          </b-button>
        </div>
      </template>
    </Multiselect>
    <b-checkbox
      v-model="moveTemplate"
      class="mt-3"
    >
      Move template
    </b-checkbox>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { copyToLayoutEventBroker, EVENTS } from "@frontend/group/modules/copy-to-layout/event-broker";
import layoutAPI from "@frontend/services/api/layout";
import templateAPI from "@frontend/services/api/template";

let timer;

export default {
  name: 'CopyToLayoutModal',
  components: { Multiselect },

  data() {
    return {
      preview: null,
      instanceId: null,
      customerId: null,
      layoutId: null,
      layouts: [],
      page: 1,
      searchKey: null,
      layoutsTotalCount: null,
      isLoading: false,
      selectedLayout: null,
      moveTemplate: false,
      layoutOption: 'existing',
      createNewLayout: 'false',
      newLayoutName: '',

    };
  },

  mounted() {
    copyToLayoutEventBroker.on(EVENTS.INIT, this.init.bind(this));
   

  },

  methods: {
    init({ preview, id, customer, layout }) {
      this.preview = preview;
      this.instanceId = id;
      this.customerId = customer;
      this.layoutId = layout;

      this.getLayouts();

      this.$bvModal.show('copy-to-layout-modal');
    },

    closeModal() {
      this.$bvModal.hide('copy-to-layout-modal');
    },

    async handleSave() {
      const {data} = await  templateAPI.copyToLayout(
        this.customerId,
        this.layoutId,
        this.instanceId,
        this.preview.template.id,
        { selectedLayout: this.createNewLayout !== "true" ? this.selectedLayout[0].id : null, moveTemplate: this.moveTemplate, layoutOption: this.layoutOption, createNewLayout: this.createNewLayout, newLayoutName: this.createNewLayout === "true" ? this.newLayoutName : null }
      );

      if (data.status === 'success') {
        window.location = data.redirect_url;
      } else {
        this.$bvModal.hide('copy-to-layout-modal');
        this.$bvToast.toast('Error occurred while copying to layout', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },

    async getLayouts() {
      this.isLoading = true;

      const { data:
        { layouts, totalCount }
      } = await layoutAPI.getLayouts({
        params: {
          search: this.searchKey,
          page: this.page,
          limit: 20
        }
      });

      this.isLoading = false;

      this.layouts = this.layouts.concat(layouts);
      this.layoutsTotalCount = totalCount;
      this.page = this.page += 1;
    },

    customLabel({ id, name }) {
      return `${id} - ${name}`;
    },

    searchCustomerLayouts(search) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        this.page = 1;
        this.searchKey = search;
        this.layouts = [];

        this.getLayouts();
      }, 500);
    },
  }
};
</script>
